// http://simple.wikipedia.org/wiki/Rainbow
export const RainbowPalette = () => ["#FF0000", "#FF7F00", "#FFFF00", "#00FF00", "#0000FF", "#6600FF", "#8B00FF"]


/**
 * @class Contains an array of colors to be used as series data fill color.
 * @param {Color[]} colors The array of colors to build the palette.
 */
export class Palette {
	constructor(colors) {
		this.colors = colors
	}

	/**
	 * @param {number} index The position inside colors array (circular if index is greater than colors length).
	 * @returns {string} Returns the index-th color in colors array.
	 */
	get(index) {
		return this.colors[index === -1 ? 0 : index % this.colors.length]
	}
}
